// Parallax effect for hero section children
(function() {
  const heroSections = document.querySelectorAll('.hero-with-scrolling-text');

  if (!heroSections.length) return;

  function updateParallax() {
    heroSections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const scrollProgress = -rect.top / (rect.height + window.innerHeight);

      // Only apply parallax when section is in viewport
      if (scrollProgress >= -0.2 && scrollProgress <= 1.2) {
        const inner = section.querySelector('.inner');
        if (!inner) return;

        // Different speeds for each child (slower = more parallax)
        const speeds = [0.2, 1.5, 0.2, 0.4, 0.6];
        // Initial offset for elements 2 onwards (5% of section height higher)
        const initialOffsets = [0, -rect.height * 0.05, -rect.height * 0.05, -rect.height * 0.05, -rect.height * 0.05];

        speeds.forEach((speed, index) => {
          const offset = scrollProgress * 100 * speed + initialOffsets[index];
          inner.style.setProperty(`--parallax-${index + 1}`, `${offset}px`);
        });
      }
    });
  }

  // Throttle scroll events for better performance
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateParallax);

  // Initial update
  updateParallax();
})();
